export default function() {
  return {calories: 2000}
}



// WEBPACK FOOTER //
// ./src/reducers/TestReducer.js